const getHrefStructure = (action, brand) => {
  const { slug } = brand;

  const brandIsPortal = slug === 'portal' ? '/' : '/[brandSlug]/';

  if (action === 'videoCreated') {
    return `${brandIsPortal}videos/[id]`;
  }
  if (action === 'audioCreated') {
    return `${brandIsPortal}audio/[id]`;
  }
  if (action === 'articleCreated') {
    return `${brandIsPortal}artikelen/[slug]`;
  }
  if (action === 'subscribedToBrand') {
    return '/[brandSlug]';
  }
  if (action === 'subscribedToFirstBrand') {
    return '/[brandSlug]';
  }

  return '';
};

export { getHrefStructure };
